import { Paragraph, TextRun } from "docx";
import { getI18n } from "react-i18next";
import { DRUCKPFAHL, ZUGPFAHL } from "../../constants";
import generateLvTableRow from "./generateLvTableRow";
import ConvertToString from "../Converter";

export default function generateMicropilesRow(lvData, positionNumber) {
  const t = getI18n().t;

  const textRuns = [
    new TextRun({
      text: "Mikropfähle",
      bold: true,
    }),
    new TextRun({
      text: "Mikropfahl nach DIN EN 14199 / DIN SPEC 18539 mit allgemeiner bauaufsichtlicher Zulassung.",
      break: 1,
    }),
    new TextRun({ text: lvData.operationDurationHumanReadable, break: 1 }),
    new TextRun({
      text:
        "Beanspruchung auf " +
        (lvData.loadDirection === ZUGPFAHL
          ? "Zug"
          : lvData.loadDirection === DRUCKPFAHL
            ? "Druck"
            : ""),
      break: 1,
    }),
    new TextRun({
      text: "Bei Pfählen mit Wechsellast ist die Beanspruchung manuell anzupassen.",
      break: 1,
      italics: true,
      color: "6E6E6E",
    }),
    new TextRun({
      text: "Bemessungswert der Tragfähigkeit Rd = " + lvData.permissibleLoadCapacity + " kN",
      break: 1,
    }),
    new TextRun({
      text:
        "Tragglied ist ein Stahlrohre mit: " +
        lvData.outsideDiameter +
        " mm Außen- und " +
        lvData.insideDiameter +
        " mm",
      break: 2,
    }),
    new TextRun({
      text: "Innendurchmesser, mit durchgehendem Betonstahlgewinde DIN 488, Ausgangsmaterial Feinkornbaustahl S 460 NH nach DIN EN 10210, inkl. Kopplungsmuffen und Abstandhalter im Abstand ≤ 3 m, sowie verlorener Bohrkrone.",
      break: 1,
    }),
    new TextRun({
      text:
        "Ischebeck " + lvData.carryingElement + " nach Zulassung Z-34.14-209 oder gleichwertig.",
      break: 1,
    }),
    new TextRun({
      text: "__________________________________________",
      break: 3,
    }),
    new TextRun({
      text: "Stahltragglied vom Bieter einzutragen",
      break: 1,
      italics: true,
    }),
    new TextRun({
      text: "Pfahllänge: " + lvData.totalPileLengthOneDecimal + "m",
      break: 2,
    }),
    new TextRun({
      text: "(Die Pfahllänge wird abgerechnet vom erdseitigen Pfahlende bis Oberkante Pfahlkopf.)",
      break: 1,
      italics: true,
    }),
    new TextRun({
      text: "Pfahlneigung zur Vertikalen: " + lvData.pileInclinationVerticle + "°",
      break: 2,
    }),
    new TextRun({
      text: "Pfahldurchmesser: " + lvData.pileDiameter + "mm",
      break: 2,
    }),
    new TextRun({
      text: "Herstellung in:",
      break: 2,
    }),
    new TextRun({
      text: "Baugrundbeschreibung nach DIN 18301, eventuell mit Verweis auf Baugrundgutachten:",
      break: 1,
      color: "6E6E6E",
      italics: true,
    }),
    new TextRun({
      text: "Zementverbrauch und Zementgüte sind entsprechend den geotechnischen Erfordernissen und der Zulassung zu ermitteln. Herstellung gemäß Zulassung, Spülmedium und Bohrlochstabilisierung angepasst an Baugrundverhältnisse, dynamisches Verpressen vom Bohrlochtiefsten mit Zement W/Z = 0,4 - 0,5, fck,cyl ≥ 35 N/mm², gemäß Zulassung. Führung eines Herstellungsprotokolls für jeden Pfahl.",
      break: 2,
    }),
    new TextRun({
      text: "Das Durchbohren von Hindernissen wird gesondert vergütet.",
      break: 1,
    }),
  ];

  const descriptionParagraph = new Paragraph({
    children: textRuns,
  });

  return generateLvTableRow(
    positionNumber,
    descriptionParagraph,
    ConvertToString(lvData.numberOfPiles),
    "Stk"
  );
}
